export default __webpack_public_path__ + "static/media/fireflink-cloud.67617ad9.svg";